import { useMutation, useQueryClient } from '@tanstack/react-query';
import { likeGoodsService } from 'shared/src/api';
import { queryKey } from 'shared/src/constant';
import type { GetMemberInfoResponse } from 'shared/src/api/getMemberInfo/types';

export const useRemoveLikeGoods = () => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: likeGoodsService.delete,
    onSuccess: ({ data }) => {
      queryClient.invalidateQueries({
        queryKey: queryKey.getInfiniteLikeFolders,
      });
      queryClient.setQueryData<GetMemberInfoResponse>(
        queryKey.myInfo,
        oldData => {
          if (!oldData) return oldData;

          return {
            ...oldData,
            likes_count: data.likes_count,
          };
        },
      );
    },
  });
};
